/**
 * @generated SignedSource<<b70f326c7fa68fd3dcbf570d532f234c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthenticationTemplate_query$data = {
  readonly company: {
    readonly features: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AuthenticationTemplate_query";
};
export type AuthenticationTemplate_query$key = {
  readonly " $data"?: AuthenticationTemplate_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuthenticationTemplate_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationTemplate_query",
  "selections": [
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "features",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1e268a0d62bc1dd6ec2867bf264e91dc";

export default node;
